import { EMPTY_LIST } from '../../../../constants/common'
import { isSystemPostType, isTvTickerPostType } from '../../Newsboard.utils'

export function getNewsboardPostFiles(data) {
  return data?.file_objs || EMPTY_LIST
}

// Ticker posts accept no files even when the post itself is editable
export function getCanEditNewsboardPostFiles(data) {
  return (
    Boolean(data?.permissions?.can_edit) &&
    !isTvTickerPostType(data) &&
    !isSystemPostType(data)
  )
}

// One entry per finished name — a same-named file of another batch stays
export function getRemainingUploadingFiles(uploadingFiles, finishedFiles) {
  const finishedNames = finishedFiles.map(f => f.name)

  return uploadingFiles.filter(file => {
    const index = finishedNames.indexOf(file.name)

    if (index === -1) {
      return true
    }

    finishedNames.splice(index, 1)

    return false
  })
}
